var _require = require('../primitives'),
    STRING = _require.STRING;

var _require2 = require('../../util'),
    mergeRule = _require2.mergeRule;

var float = require('./float');

module.exports = mergeRule(STRING, float, function (val) {
  return Number(val);
});